import { apiGetRequest } from '../../../../utils/api/get';
import { ChargerStatusResponse } from '../../../reports/model/reports';
import { BASE_URL } from '../../../../utils/auth';

export const fetchVendorChargerStatusAPI = (
  token: string,
  stationId?: number
): Promise<ChargerStatusResponse> =>
  apiGetRequest<ChargerStatusResponse>({
    apiUrl: `${BASE_URL}/vendor-reports/charger-status`,
    token,
    params: { stationId },
  });
